import isPlainObject from 'lodash/isPlainObject'
import { marxy } from '../initMarxy'
import { MarxyEvents } from '~/utils/marxy/types'
import { axiosMarxyRetryer } from '~/utils/marxy/api'
import { webApi } from '~/utils/webApi'

/**
 * Tracks a item view on product detail
 */
const trackViewItem = async (id: string) => {
  if (!id) {
    console.error('Marxy viewItem: property id is undefined')
    return
  }

  try {
    const res = await axiosMarxyRetryer(
      async () => await webApi.findVariants([id])
    )
    const product = res.entities[0]
    if (!isPlainObject(product)) {
      // It happens very often on non-existent products
      return
    }
    const categories = product.mainMenuPath
    const productData = {
      brand: product.brandTitle,
      categories_list: categories,
      categories_path: categories.join(' > ') || [],
      category_id: product.product.productTypeId,
      category_name: categories[categories.length - 1],
      price: product.price.actualPrice,
      product_id: product.product.entityId,
      title: `${product.brandTitle} ${product.title}`,
      variant_id: String(product.variantId),
    }
    marxy.trackEvent(MarxyEvents.VIEW_ITEM, productData)
  } catch (error) {
    throw new Error(
      `Marxy viewItem: Compile event data failed because [${error.message}]`
    )
  }
}

export default trackViewItem
